import { render, staticRenderFns } from "./SiblingsStep.vue?vue&type=template&id=60f69323&"
import script from "./SiblingsStep.vue?vue&type=script&lang=js&"
export * from "./SiblingsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports